import { RecordTableWrapper } from './record-table-wrapper';
import { Skeleton } from '~/components/Skeleton/Skeleton';
import { Heading } from '~/components/Heading/Heading';
import { Table } from '~/components/Table/Table';

export function RecordTableLoading() {
  return (
    <div>
      <Heading as="h3">
        <Skeleton style={{ width: '170px', height: 'var(--size-6)' }} />
      </Heading>

      <RecordTableWrapper>
        <Table.Loading cols={7} />
      </RecordTableWrapper>
    </div>
  );
}
